// extracted by mini-css-extract-plugin
export var activeFilterButton = "_oa-c";
export var backButton = "_oa-4";
export var backIcon = "_oa-5";
export var chevronShortcut = "_oa-6";
export var container = "_oa-1";
export var editor = "_oa-8";
export var editorWrapper = "_oa-7";
export var prefix = "_oa-2";
export var searchIcon = "_oa-3";
export var suffix = "_oa-9";
export var suffixContent = "_oa-a";
export var suffixText = "_oa-b";
export var wrapper = "_oa-0";